// @ts-nocheck
import {toast} from "@/components";

/**
 * Thin shim preserving the legacy `CustomNotification.success/error/warning(...)` API
 * used across Lottery hooks. Forwards to the unified toast store.
 *
 * Accepts either a plain string or `{message, action?: {text, onClick}, duration?}`.
 */
const normalize = config => {
  if (typeof config === "string") return {message: config};
  return config || {};
};

const toToastArgs = cfg => {
  const base = {
    title: cfg.message,
    duration: cfg.duration === 0 ? 0 : (cfg.duration ?? 4) * 1000,
  };
  if (cfg.action?.text && cfg.action?.onClick) {
    base.action = {label: cfg.action.text, onClick: cfg.action.onClick};
  }
  return base;
};

const CustomNotification = {
  success: config => toast.success(toToastArgs(normalize(config))),
  error: config => toast.error(toToastArgs(normalize(config))),
  warning: config => toast.warning(toToastArgs(normalize(config))),
};

export default CustomNotification;
